import { useContext } from 'react';
import { DeleteTenantModalContext } from './DeleteTenantModalContext';

const useDeleteTenantModal = () => {
  const { open } = useContext(DeleteTenantModalContext);
  return { open };
};

export default useDeleteTenantModal;
